import { useTranslation } from 'react-i18next';

import { SearchMenuItem } from '@/ui-kit/header/SearchMenuItem';
import { TSearchGroup } from '@/hooks/search/useSearch.types';
import {
  TDashboardConfigSettingsSearch,
  TDashboardConfigSettingsSearchGroup,
} from '@/store/models/dashboard-config.model';
import { useKeyboardNavigation } from '@/hooks/useKeyboardNavigation';

interface ISearchMenuProps {
  searchGroups: TSearchGroup;
  handleItemSelected: (value: TDashboardConfigSettingsSearch, group: TDashboardConfigSettingsSearchGroup) => void;
  isOpen?: boolean;
}

export function SearchMenu({ searchGroups, handleItemSelected, isOpen }: ISearchMenuProps) {
  const { t } = useTranslation();

  const { ref: navigationRef, selectedItem } = useKeyboardNavigation(searchGroups, handleItemSelected, isOpen);

  return (
    <div ref={navigationRef} className="flex flex-col justify-start p-4 gap-4">
      {Object.entries(searchGroups).map(([key, items], rowIndex) => {
        return (
          <div key={`search-group-${key}`} className="flex flex-col gap-3">
            <span className="typo-subtitle-subtitle3 text-tertiary">
              {t(`pages.dashboard.search.forms.group.${key}`)}
            </span>
            <div className="flex items-center gap-3">
              {items.map((item, itemIndex) => (
                <SearchMenuItem
                  key={`search-group-item-${item.value}`}
                  label={t(`pages.dashboard.search.forms.${item.value}`)}
                  onSelectItem={() => handleItemSelected(item.value, key as TDashboardConfigSettingsSearchGroup)}
                  {...item}
                  isSelected={selectedItem.rowIndex === rowIndex && selectedItem.itemIndex === itemIndex}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
